<template>
    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
</template>

<style lang="scss" scoped>
.lds-ring {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    min-width: 168px;
}
.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 24px;
    height: 24px;
    margin: 8px;
    border: 3px solid #F5F5F5;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #F5F5F5 transparent transparent transparent;

    &:hover {
        border: 3px solid white;
        border-color: white transparent transparent transparent;

    }
}
.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

</style>

<script>
export default {
    name: "Loader",
    setup() {

    }
}
</script>